import React from 'react';
import { LogoutRounded as LogoutRoundedIcon } from '@mui/icons-material';
import { Box, List, ListItemButton, Typography } from '@mui/material';
import { guaranteesLayoutStyles } from '../../styles.ts';
import ExpandedNavigationItem from './ExpandedNavigationItem.tsx';
import type { IExpandedNavigationSectionProps } from './types.ts';

const ExpandedNavigationSection: React.FC<IExpandedNavigationSectionProps> = ({
  currentPath,
  expandedGroupSegments,
  menuItems,
  onLogout,
  onNavigate,
  onToggleGroup,
}) => {
  return (
    <>
      <Box sx={guaranteesLayoutStyles.menuPanelBody}>
        <List disablePadding sx={guaranteesLayoutStyles.menuList}>
          {menuItems.map((item) => (
            <ExpandedNavigationItem
              key={item.segment}
              currentPath={currentPath}
              isExpanded={expandedGroupSegments.includes(item.segment)}
              item={item}
              onNavigate={onNavigate}
              onToggle={() => onToggleGroup(item.segment)}
            />
          ))}
        </List>
      </Box>

      <Box sx={guaranteesLayoutStyles.menuFooter}>
        <ListItemButton
          onClick={onLogout}
          sx={[guaranteesLayoutStyles.menuItemButton(false), guaranteesLayoutStyles.logoutButton]}
        >
          <Box sx={guaranteesLayoutStyles.menuItemContent}>
            <Box sx={guaranteesLayoutStyles.menuItemLeading}>
              <Box sx={guaranteesLayoutStyles.menuItemIconWrap(false)}>
                <LogoutRoundedIcon sx={guaranteesLayoutStyles.menuItemIcon(false)} />
              </Box>
              <Box sx={guaranteesLayoutStyles.menuItemLabelWrap}>
                <Typography sx={guaranteesLayoutStyles.logoutButtonText}>Вийти</Typography>
              </Box>
            </Box>
          </Box>
        </ListItemButton>
      </Box>
    </>
  );
};

export default ExpandedNavigationSection;
